import { createSlice } from "@reduxjs/toolkit";

import { IFilters, ITags } from "@/models/models";
import { availableTags, tags } from "@/store/actions/filters";

export interface FiltersState {
  filters: IFilters;
  tags: ITags[];
  availableTags: Record<string, boolean> | null;
  loading: boolean;
  loadingFilters: boolean;
}

const initialFilters: IFilters = {
  composer: [],
  tags: [],
  availableTags: null,
  length: {},
  bpm: {},
};

const initialTags: ITags[] = [];

const initialState: FiltersState = {
  filters: initialFilters,
  tags: initialTags,
  availableTags: null,
  loading: true,
  loadingFilters: true,
};

const { reducer, actions } = createSlice({
  name: "filters",
  initialState,
  reducers: {
    resetFiltersState: (state) => {
      state.filters = { ...initialFilters };
    },
    setFiltersState: (state, { payload }) => {
      state.filters = { ...payload };
      state.loadingFilters = false;
    },
    setAvailableTagsState: (state, { payload }) => {
      state.availableTags = payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(tags.fulfilled, (state, { payload }) => {
      if (!payload) {
        return;
      }

      state.tags = payload as ITags[];
      state.loading = false;
    });

    builder.addCase(availableTags.fulfilled, (state, { payload }) => {
      if (!payload.availableTags) {
        return;
      }

      state.availableTags = Object.fromEntries(payload.availableTags.map((key) => [key, true]));
    });
  },
});

export const { setAvailableTagsState } = actions;

export default reducer;
